module.exports = __webpack_public_path__ + "static/img/home_jrtt_pic1.a7bf3a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_jrtt_pic1.png
// module id = l7DO
// module chunks = 0